module.exports = __webpack_public_path__ + "static/media/vgu-logo1.f1f205f6.jpg";